module.exports = __webpack_public_path__ + "static/media/aboutBg.6ef6d4c8.png";